const PREFIX = 'APP_'

export const SET_CATEGORY = PREFIX + 'SET_CATEGORY';